/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useConsumerMyPageHeader } from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import SimplifiedMegaMenuWrapper from 'bundles/megamenu/components/SimplifiedMegaMenuWrapper';
import MegaMenuLinksProvider from 'bundles/megamenu/providers/MegaMenuLinksProvider';

const styles = {
  exploreButtonHeaderSpacing: css`
    margin-right: calc(var(--cds-spacing-100) * -1);
  `,
};

const ExploreMegaMenuGridItem = () => {
  const { hasEnrolledPrograms, isCourseraPlusLearner } = useConsumerMyPageHeader();

  return (
    <MegaMenuLinksProvider>
      <div className="rc-ExploreMegaMenuGridItem" css={styles.exploreButtonHeaderSpacing}>
        <SimplifiedMegaMenuWrapper shouldShowCourseraPlusButton={!isCourseraPlusLearner && !hasEnrolledPrograms} />
      </div>
    </MegaMenuLinksProvider>
  );
};

export default ExploreMegaMenuGridItem;
